// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".briq-panel[data-v-45f789d8] {\n  background: #fff;\n  border: 1px solid #ebebeb;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.5);\n  border-radius: 3px;\n}\n.briq-panel-body[data-v-45f789d8] {\n  width: 100%;\n}\n.briq-panel-header[data-v-45f789d8] {\n  display: flex;\n  justify-content: space-between;\n}\n.briq-panel-footer[data-v-45f789d8] {\n  display: flex;\n}\n", ""]);
// Exports
module.exports = exports;
